import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { requiredTrimmed } from '../../../utils/utils';
import { InputComponent } from '../../from-input/input.component';

@Component({
    selector: 'add-region',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, InputComponent],
    templateUrl: './add-region.component.html',
    styleUrls: ['./add-region.component.scss']
})
export class AddRegionComponent implements OnInit, OnDestroy {
    @Input() initialData: any = null;
    @Input() loading: boolean = false;
    @Output() formSubmitted = new EventEmitter<any>();
    @Output() formValidation = new EventEmitter<boolean>();

    form!: FormGroup;
    private dialogConfirmListener?: (event: Event) => void;

    customErrorMessages = {
        eventHostRegionName: {
            required: 'Please enter a region name.'
        },
        eventHostRegionInitial: {
            whitespace: 'Please enter a valid region initial.'
        }
    };

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.initForm();
        this.setupDialogListener();
    }

    ngOnDestroy(): void {
        this.cleanupDialogListener();
    }

    private initForm(): void {
        const initialStatus = this.initialData
            ? this.initialData.status === 'Active'
            : true;

        this.form = this.fb.group({
            eventHostRegionName: [this.initialData ? this.initialData['region name'] ?? this.initialData.regionName ?? '' : '', requiredTrimmed],
            eventHostRegionInitial: [
                this.initialData ? this.initialData['region initial'] ?? this.initialData.regionInitial ?? '' : '',
                [this.noWhitespaceValidator.bind(this)]
            ],
            status: [initialStatus]
        });

        this.formValidation.emit(this.form.valid);
        this.form.valueChanges.subscribe(() => {
            this.formValidation.emit(this.form.valid);
        });
    }


    private noWhitespaceValidator(control: AbstractControl): { [key: string]: any } | null {
        if (control.value && control.value.trim().length === 0) {
            return { whitespace: true };
        }
        return null;
    }

    private setupDialogListener(): void {
        this.dialogConfirmListener = () => this.handleDialogConfirm();
        document.addEventListener('dialogConfirm', this.dialogConfirmListener);
    }

    private cleanupDialogListener(): void {
        if (this.dialogConfirmListener) {
            document.removeEventListener('dialogConfirm', this.dialogConfirmListener);
        }
    }

    handleDialogConfirm(): void {
        if (this.form.valid) {
            const formValue = this.form.value;
            if (formValue.eventHostRegionInitial) {
                formValue.eventHostRegionInitial = formValue.eventHostRegionInitial.trim();
            }
            this.formSubmitted.emit(formValue);
        } else {
            this.markFormAsTouched();
        }
    }

    onSubmit(): void {
        this.handleDialogConfirm();
    }

    private markFormAsTouched(): void {
        this.form.markAllAsTouched();
    }

    isFormValid(): boolean {
        return this.form.valid;
    }
}